import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
import { ThemeProvider } from "./contexts/ThemeContext";
import { registerServiceWorker } from "./utils/serviceWorkerManager";
import { performanceMonitor } from "./utils/performanceMonitoring";
import { AuthProvider } from "./contexts/AppContexts";

// Initialize performance monitoring
performanceMonitor.startMeasure("app-initialization");

if ("serviceWorker" in navigator) {
	if (import.meta.env.PROD) {
		// Register Service Worker for offline support (only in production)
		registerServiceWorker("/service-worker.js")
			.then(() => console.log("Service Worker registered"))
			.catch((err) => console.error("Service Worker registration failed:", err));
	} else {
		// In dev make sure no stale service worker serves old assets
		navigator.serviceWorker.getRegistrations().then((regs) => {
			regs.forEach((reg) => reg.unregister());
		});
		if ("caches" in window) {
			caches.keys().then((names) => {
				names.forEach((name) => caches.delete(name));
			});
		}
	}
}

createRoot(document.getElementById("root")!).render(
	<ThemeProvider>
		<AuthProvider>
			<App />
		</AuthProvider>
	</ThemeProvider>,
);

performanceMonitor.endMeasure("app-initialization");
